/**
 * relationships-configuration-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { RelationshipTypeData, Role }
  from "../../../subjects/relationship";
import { validateAs, validateFor, validateOpaqueID, validateTSEnum }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

@validateFor(MessageTag.RSP_CFG_RELATIONSHIPS)
export class RelationshipsConfigurationResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_CFG_RELATIONSHIPS;

  /**
   * The relationship roles defined by the system.
   * @type {number}
   */
  @validateAs({array: "object"}) // TODO: refine
  public roles : Role[];

  /**
   * The relationships defined by the system and their role / type restrictions.
   */
  @validateAs({array: "object"}) // TODO: refine
  public relationships : RelationshipTypeData[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/subjects/relationships-configuration-response.ts